<template>
  <div class="location-page c-layout">
    <div class="breadcrumbs c-layout hide-on-pad">
      <span>{{ $t('breadcrumbs.home') }}</span>
      <span class="p-16">/</span>
      <span :class="{ 'o-color':step!=3 }">{{ $t('breadcrumbs.location') }}</span>
      <span class="p-16" v-show="step==3">/</span>
      <span class="o-color" v-show="step==3">{{ $t('location.step_3_desc') }}</span>
    </div>
    <div class="page-title">{{ $t('breadcrumbs.location') }}</div>
    <div class="page-container">
      <div class="page-right">
        <div class="search-block" v-show="step==1 || step==2">
          <div class="steps show-on-pad-flex">
            <div class="line-bg show-on-pad"></div>
            <div class="line show-on-pad" :style="{ width: getLineWidth }"></div>
            <div class="step-item" :class="{ active:step>='1' }"><span class="step-title hide-on-pad">電腦版才有</span><span class="step-index show-on-pad-flex">1</span></div>
            <div class="step-item" :class="{ active:step>='2' }"><span class="step-title hide-on-pad">電腦版才有</span><span class="step-index show-on-pad-flex">2</span></div>
            <div class="step-item" :class="{ active:step>='3' }"><span class="step-title hide-on-pad">電腦版才有</span><span class="step-index show-on-pad-flex">3</span></div>
          </div>

          <div class="step-content" :class="{ active:step==1 }">
            <div class="step-block">STEP1 | {{ $t('location.step_1_desc') }}</div>
            <div class="area-block">
              <div class="area-img" :class="{ active: chooseBarea==index }" v-for="(item,index) in areaimg" :key="index+'_area_img'">
                <picture>
                  <source :srcset="item.mob" media="(max-width: 992px)">
                  <img class="img-responsive" :src="item.pc" alt />
                </picture>
              </div>
            </div>
            <div class="barea-block">
              <div class="barea-item" @click="chooseBarea=index;chooseprovince=''" :class="{ active: chooseBarea===index }" v-for="(item,index) in areaMap" :key="index+'_barea'">{{ item.name }}</div>
            </div>
          </div>

          <div class="step-content" :class="{ active:step==2 }">
            <div class="step-block">STEP2 | {{ $t('location.step_2_desc') }}</div>
            <div class="barea-block">
              <div class="barea-item" @click="chooseprovince=index" :class="{ active: chooseprovince===index }" v-for="(item,index) in areaMap[chooseBarea].province" :key="index+'_barea'">{{ item.name }}</div>
            </div>
            <div class="page-line"></div>
          </div>
          <div class="btn btn-orange submit hide-on-pad-flex" @click="handlePcSearchBtn"><Icon type="search" @clickevent="handlePcSearchBtn" />{{ $t('btns.search_store') }}</div>
          <div class="btn btn-orange submit float-bottom show-on-pad-flex" @click="handleMobSearchBtn"><Icon type="search" @clickevent="handleMobSearchBtn" />{{ step==3?$t('btns.search_store'):$t('btns.next') }}</div>
        </div>

        <div class="result-list-block" v-show="step==3" v-loading="isloading">
          <div class="result-search-item">
            <div class="search-item">{{ $t('location.range') }}：{{ getChooseBarea }}</div>
            <div class="search-item">{{ $t('location.province') }}：{{ getChooseProvince }}</div>
          </div>
          <div class="result-list" v-if="stores.length>0">
            <div class="result-item" v-for="(item,index) in stores" :key="item.retailer_id+'_result_list'">
              <div class="img-block">
                <img :src="item.photo" alt="location img">
              </div>
              <div class="desc">
                <p class="title">{{ item.name}}</p>
                <p class="tel">{{ $t('location.tel') }}: {{ item.telphone }}</p>
                <p class="addr">{{ $t('location.addr') }}: {{ getProvince(item.big_area,item.province) }}{{ item.address }}</p>
                <Icon type="3D" v-if="item.facility.includes(1)"/>
              </div>
              <div class="btn-block">
                <div class="btn btn-orange" @click="handleChooseStore(index)">MAP</div>
              </div>
            </div>
          </div>
          <div class="no-result mb-20" v-else>
            {{ $t('location.no_result') }}
          </div>
          <div class="btn btn-orange btn-back hide-on-pad-flex" @click="handleBack">{{ $t('btns.back') }}</div>
          <div class="btn btn-orange submit float-bottom show-on-pad-flex" @click="handleBack">{{ $t('btns.back') }}</div>
        </div>

        <div class="store-info" v-show="step==4">
          <div class="step-block">{{ getStoreDetail.name }}</div>
            <div class="store-banner">
              <img :src="getStoreDetail.photo2">
            </div>
            <div class="store-info-block">
              <div class="store-info-detail">
                <div class="store-name">{{ getStoreDetail.name }}</div>
                <p>{{ getProvince(getStoreDetail.big_area,getStoreDetail.province) }}{{ getStoreDetail.address }}</p>
                <p>{{ $t('location.tel') }}: {{ checkEmpty(getStoreDetail.telphone) }}</p>
                <p>{{ $t('location.open_time') }}: {{ checkEmpty(getStoreDetail.bussinessTime) }}</p>
                <p>{{ $t('location.break_date') }}: {{ checkEmpty(getStoreDetail.offTime) }}</p>
                <div class="logos">
                  <div class="logo"><img :src="visa_logo"></div>
                  <div class="logo"><img :src="mastercard_logo"></div>
                  <!-- <div class="logo"><img :src="discover_logo"></div> -->
                  <Icon type="3D" v-if="getStoreDetail.facility && getStoreDetail.facility.includes(1)"></Icon>
                </div>
              </div>
              <div class="store-map">
                <!-- <img :src="mapimg"> -->
                <baidu-map 
                  class="baidu-map" 
                  :center="mapCenter" 
                  :zoom="mapZoom"
                >
                  <bm-marker :position="mapCenter" :dragging="false" animation="BMAP_ANIMATION_BOUNCE" />
                  <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
                </baidu-map>
              </div>
            </div>
            <div class="page-btn-block">
              <div class="btn btn-orange btn-back" @click="handleBack">{{ $t('btns.back') }}</div>
            </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import userSideMenu from '../../components/UserSideMenu';
import img01_mob from './images/01.png'
import img01 from './images/01@2x.png'
import img02_mob from './images/02.png'
import img02 from './images/02@2x.png'
import img03_mob from './images/03.png'
import img03 from './images/03@2x.png'
import img04_mob from './images/04.png'
import img04 from './images/04@2x.png'
import img05_mob from './images/05.png'
import img05 from './images/05@2x.png'
import img06_mob from './images/06.png'
import img06 from './images/06@2x.png'
import img07_mob from './images/07.png'
import img07 from './images/07@2x.png'
import fakeImg from './images/001-098@2x.png'
import storebanner from './images/storebanner.png'
import visa_logo from './images/visa_logo.png'
import mastercard_logo from './images/mastercard_logo.png'
import discover_logo from './images/discover_logo.png'

import { getLocations } from "../../api";
var myGeo = new BMap.Geocoder(); 

  export default {
    name: 'location',
    data() {
      return {
        fakeImg,storebanner,visa_logo,mastercard_logo,discover_logo,
        areaimg: [
          { pc: img01, mob: img01_mob },
          { pc: img02, mob: img02_mob },
          { pc: img03, mob: img03_mob },
          { pc: img04, mob: img04_mob },
          { pc: img05, mob: img05_mob },
          { pc: img06, mob: img06_mob },
          { pc: img07, mob: img07_mob },
        ],
        areaMap: this.$t('area'),
        chooseBarea:0,
        chooseprovince: '',
        isloading: false,
        step: 1,
        stores: [],
        chooseStore: '',
        mapCenter: {lng:0,lat:0},
        mapZoom: 18,
      }
    },
    components: {
      userSideMenu
    },
    filters: {
      
    },
    computed: {
      getLineWidth() {
        switch(this.step) {
          case 1:
            return '30px';
            break;
          case 2:
            return '49%';
            break;
          case 3:
            return 'calc(100% - 32px)';
            break;
        }
      },
      getChooseBarea() {
        if(this.chooseBarea!=='') {
          return this.areaMap[this.chooseBarea].name;
        }else{
          return '';
        }
      },
      getChooseProvince() {
        if(this.chooseprovince!=='') {
          return this.areaMap[this.chooseBarea].province[this.chooseprovince].name;
        }else{
          return '';
        }
      },
      getStoreDetail() {
        if(this.chooseStore!==''  && this.stores.length>0) {
          return this.stores[this.chooseStore];
        }else{
          return '';
        }
      },
    },
    methods: {
      checkEmpty(value) {
        if(String(value).trim() != '' && value != null) {
          return value;
        }else{
          return this.$t('format.no_supply');
        }
      },
      getProvince(big_area_id,province_id) {
        console.log('big_area_id',big_area_id);
        const area = this.areaMap.filter(item => item.id==big_area_id);
        console.log('area',area);
        if(area.length==0) return this.$t('format.error');
        const province = area[0].province.filter(item => item.id==province_id);
        if(province.length>0){
          return province[0].name;
        }else{
          return this.$t('format.error');
        }
      },
      handlePcSearchBtn() {
        this.searchLocation();
      },
      handleMobSearchBtn() {
        console.log('this.step',this.step);
        if(this.step==1) {
          this.step +=1;
          window.scrollTo({'behavior': 'smooth', 'top': 0})
          return;
        }
        if(this.step==2) {
          if(!this.chooseprovinc==='') {
            this.$message({
              message: this.$t('alert_message.choose_area'),
              type: 'warning'
            });
            return;
          }
          // 搜寻
          window.scrollTo({'behavior': 'smooth', 'top': 0})
          this.searchLocation();
        }
      },
      async searchLocation() {
        if(this.chooseprovince!=='') {
          this.step = 3;
          this.isloading = true;
          const bigarea = this.areaMap[this.chooseBarea].id;
          const province = this.areaMap[this.chooseBarea].province[this.chooseprovince].id;
          // 送出api
          const { store } = await getLocations({ bigarea,province });
          // 整理一下 facility 有出现1的话就显示3D图片
          store.map(item => {
            const newFacility = JSON.parse(item.facility);
            return { ...item, facility:newFacility }
          })
          this.stores = store;
          this.isloading = false;
        }else{
          this.$message({
            message: this.$t('alert_message.choose_area'),
            type: 'warning'
          });
          return;
        }
      },
      handleBack() {
        this.step = 1;
      },
      handleChooseStore(index) {
        this.chooseStore = index;
        const store = this.stores[index];
        const address = `${this.getChooseProvince}${store.address}`;
        console.log('address',address);
        myGeo.getPoint(address, (point) => {      
            if (point) {
                this.mapCenter = point;
            }      
        },this.stores[index].province);
        this.step = 4;
        window.scrollTo({'behavior': 'smooth', 'top': 500})
      },
    }
  }
</script>

<style lang="less" scoped>
.location-page {
  .page-title {
    margin-bottom: 0;
  }
  .page-container {
    border-top: unset;
  }
  .step-block {
    background: #F0F0F0;
    padding: 20px;
    text-align: center;
    margin-bottom: 30px;
  }
  .steps {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    position: relative;
    margin-bottom: 20px;
    .step-item {
      font-weight: 400;
      color: #707070;
      &.active {
        color: #FF5214;

      }
    }
    @media (max-width: 992px) {
      padding-left: 0%;
      padding: 0 16px;
      border-bottom: unset;
      .line {
        position: absolute;
        width: calc(100% - 32px);
        height: 3px;
        background: #FF5214;
        border-radius: 3px;
        z-index: -1;
        top: 50%;
        transform: translateY(-50%);
      }
      .line-bg {
        position: absolute;
        width: calc(100% - 32px);
        height: 3px;
        background: #F5F4F8;
        border-radius: 3px;
        z-index: -1;
        top: 50%;
        transform: translateY(-50%);
      }
      .step-item:nth-child(3) {
        margin-left: 30px;
      }
      .step-item:nth-last-child(1) {
        margin-right: 30px;
      }
      .step-index {
        background: white;
        color:#E6E6E6;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        border: 2px solid #E6E6E6;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        &::after {
          content: '';
          position: absolute;
          height: 28px;
          width: 28px;
          left: -5px;
          top: -5px;
          border: 3px solid white;
          border-radius: 50%;
        }
      }
      .step-item {
        font-weight: 400;
        color: #707070;
        &.active {
          .step-index {
            background: #FF5214;
            border: 2px solid #FF5214;
            color: white;
          }
        }
      }
    }
  }
  .page-right {
    width: 100%;
  }
  .area-block {
    padding-bottom: 30px;
    width: 50%;
    margin: auto;
    .area-img {
      display: none;
      width: 100%;
      &.active {
        display: block;
      }
    }
  }
  .barea-block {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    width: 50%;
    margin: auto;
    .barea-item {
      flex: 0 0 calc(25% - 15px);
      margin-right: 20px;
      border: 1px solid #101010;
      text-align: center;
      padding: 10px 0;
      margin-bottom: 20px;
      cursor: pointer;
      &:nth-child(4n) {
        margin-right: 0;
      }
      &.active {
        background: #EC4F00;
        border: 1px solid #EC4F00;
        color: white;
      }
    }
  }
  .page-line {
    width: 100%;
    height: 1px;
    background: #E6E6E6;
    margin-top: 60px;
    margin-bottom: 30px;
  }
  .submit {
    width: 160px;
    line-height: 24px;
    margin: auto;
    margin-bottom: 60px;
    .cloud-icon {
      fill: white;
      margin-right: 5px;
    }
    &.float-bottom {
      position: fixed;
      width: 100%;
      bottom: 0;
      left: 0;
      margin-bottom: 0;
      z-index: 10;
    }
  }
  .result-list-block {
    .result-search-item {
      background: #F0F0F0;
      display: flex;
      margin-bottom: 30px;
      padding-left: 20px;
    }
    .search-item {
      text-align: center;
      padding: 20px 20px;
    }
    .result-list {
      display: flex;
      flex-wrap: wrap;
      // justify-content: space-between;
      .result-item {
        margin-right: 20px;
        flex: 0 0 calc(33% - 10px);
        margin-bottom: 20px;
        position: relative;
        &:nth-child(3n) {
          margin-right: 0;
        }
      }
      .img-block {
        position: relative;
        padding-top: calc(100%/350*200);
        overflow: hidden;
        img {
          position: absolute;
          width: 100%;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
        }
      }
      .desc {
        color: #707070;
        padding: 10px 0;
        .title {
          font-weight: 400;
          margin-bottom: 10px;
        }
        .tel {
          margin-bottom: 5px;
        }
        .addr {
          margin-bottom: 20px;
        }
      }
      .btn-block {
        display: flex;
        justify-content: flex-end;
        .btn {
          width: 125px;
        }
      }
      .cloud-icon {
        height: 44px;
        width: 44px;
        fill: #707070;
        position: absolute;
        bottom: -10px;
        left: 0;
      }
    }
  }
  .btn-back {
    width: 125px;
    margin: auto;
    margin-top: 60px;
    margin-bottom: 40px;
  }
  @media (max-width: 992px) {
    .step-content {
      display: none;
      &.active {
        display: block;
      }
    }
    .step-block {
      margin-left: -15px;
      margin-right: -15px;
    }
    .area-block {
      width: 100%;
    }
    .barea-block { 
      width: 100%;
      .barea-item {
        flex: 0 0 calc(33% - 13px);
        &:nth-child(3n) {
          margin-right: 0;
        }
        &:nth-child(4n) {
          margin-right: 20px;
        }
      }
    }
    .result-list-block {
      .result-search-item {
        margin-left: -15px;
        margin-right: -15px;
        .search-item {
          position: relative;
          &:nth-child(1) {
            &::after {
              content: '';
              position: absolute;
              height: 20px;
              width: 1px;
              background: #707070;
              right: 0;
              top: 17px;
            }
          }
        }
      }
      .result-list {
        .result-item {
          flex: 0 0 100%;
        }
        .img-block {
          padding-top: calc(100%/336*242);
          overflow: hidden;
        }
        .btn-block {
          .btn {
            width: 100%;
          }
        }
        .desc {
          position: relative;
        }
        .cloud-icon {
          bottom: unset;
          top: 10px;
          left: unset;
          right: 0;
        }
      }
    }
  }
  .store-info {
    margin-bottom: 40px;
    .store-banner {
      margin-bottom: 20px;
      @media (max-width: 992px) {
        margin-right: -16px;
        margin-left: -16px;
        margin-bottom: 30px;
      }
      img {
        display: block;
        width: 100%;
      }
    } 
    .store-info-block {
      display: flex;
      margin-bottom: 40px;
      @media (max-width: 992px) {
        flex-direction: column-reverse;
      }
    }
    .store-info-detail {
      flex: 1;
      .store-name {
        color: #FF5214;
        font-weight: 400;
        font-size: 2rem;
        margin-bottom: 20px;
        @media (max-width: 992px) {
          font-size: 1.5rem;
        }
      }
      p {
        margin-bottom: 20px;
      }
      .logos {
        display: flex;
        .logo {
          width: 70px;
          margin-right: 10px;
          @media (max-width: 992px) {
            width: 50px;
          }
          img {
            display: block;
            width: 100%;
          }
        }
        /deep/ .cloud-icon {
          width: 70px;
          height: auto;
          @media (max-width: 992px) {
            width: 50px;
          }
          svg {
            fill: #828282;
            transform: translateY(10px);
            @media (max-width: 992px) {
              transform: translateY(5px);
            }
          }
        }
      }
    }
    .store-map {
      flex: 1;
      img {
        display: block;
        width: 100%;
      }
      .baidu-map {
        width: 100%;
        height: 300px;
      }
      @media (max-width: 992px) {
        margin-right: -16px;
        margin-left: -16px;
        margin-bottom: 20px;
      }
    }
    .btn {
      width: 125px;
      margin: auto;
      // @media (max-width: 992px) {
      //   position: fixed;
      //   width: 100%;
      //   bottom: 0;
      //   left: 0;
      //   z-index: 1;
      // }
    }
  }
  .page-btn-block {
    display: flex;
    justify-content: center;
    .btn {
      margin: unset;
      margin-right: 20px;
      width: 125px;
      &:nth-last-child(1) {
        margin-right: 0;
      }
    }
    @media (max-width: 992px) {
      position: fixed;
      width: 100%;
      left: 0;
      bottom: 0;
      z-index: 1;
      .btn {
        width: unset;
        flex: 1;
        margin-right: 0;
      }
    }
  }

}
</style>